"use client"; // Error boundaries must be Client Components

import Link from "next/link";
import { useEffect } from "react";

import { css } from "@/../styled-system/css";

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <div
      className={css({
        width: "90%",
        maxWidth: "1200px",
        mx: "auto",
        mt: "24",
        textAlign: "center",
      })}
    >
      <h1 className={css({ fontWeight: "bold", fontSize: "5xl", mb: "2" })}>
        Oops! Something Went Wrong
      </h1>
      <p className={css({ fontSize: "xl", mb: "4" })}>{error.message}</p>
      <Link
        className={css({
          fontSize: "xl",
          color: "brandBlue",
          textDecoration: "underline",
        })}
        href="/"
        prefetch
      >
        Return to Home Page
      </Link>
    </div>
  );
}
